import { createTeoError } from './TeoError';

const AUTH_ERROR_CODES = [
  'AuthUnauthenticatedError',
  'AuthLoginFailedError',
  'AuthLogoutFailedError',
  'AuthExpiredError',
] as const;
type AuthErrorCode = (typeof AUTH_ERROR_CODES)[number];

export class AuthError<TCode extends AuthErrorCode = AuthErrorCode> extends createTeoError(
  'AuthError',
  AUTH_ERROR_CODES,
) {
  declare readonly code: TCode;
}

export class AuthUnauthenticatedError extends AuthError<'AuthUnauthenticatedError'> {
  constructor(cause?: unknown) {
    super('AuthUnauthenticatedError', 'Nicht eingeloggt', cause);
  }
}

export class AuthLoginFailedError extends AuthError<'AuthLoginFailedError'> {
  constructor(message = 'E-Mail oder Passwort nicht korrekt.', cause?: unknown) {
    super('AuthLoginFailedError', message, cause);
  }
}

export class AuthLogoutFailedError extends AuthError<'AuthLogoutFailedError'> {
  constructor(message = 'Logout fehlgeschlagen.', cause?: unknown) {
    super('AuthLogoutFailedError', message, cause);
  }
}

export class AuthExpiredError extends AuthError<'AuthExpiredError'> {
  constructor(message = 'Anmeldung abgelaufen.', cause?: unknown) {
    super('AuthExpiredError', message, cause);
  }
}
